import React from "react";
import Marty from "marty";

let Compliance = React.createClass({
    render() {
        return (
            <section className="eo-sub-view compliance">
                <h2>FCC compliance</h2>

                <ol>
                    <li>
                        <h3>FCC radio frequency interference warnings & instructions</h3>

                        <p>This device complies with part 15 of the FCC Rules. Operation is subject to the following two conditions: (1) This device may not cause harmful interference, and (2) this device must accept any interference received, including interference that may cause undesired operation.</p>
                        <p>No Unauthorized Modifications:  Do not make any changes or modifications to the eero device without the prior express written approval of eero inc.  Any changes or modifications made without express written approval could void the user’s authority to operate the eero device.</p>
                        <p>Note: The eero device has been tested and found to comply with the limits for a Class B digital device, pursuant to part 15 of the FCC Rules. These limits are designed to provide reasonable protection against harmful interference in a residential installation. The eero device generates uses and can radiate radio frequency energy and, if not installed and used in accordance with the instructions, may cause harmful interference to radio communications. However, there is no guarantee that interference will not occur in a particular installation. If the eero device does cause harmful interference to radio or television reception, which can be determined by turning the equipment off and on, the user is encouraged to try to correct the interference by one or more of the following measures:</p>

                        <ul>
                            <li><span>Reorient or relocate the receiving antenna.</span></li>
                            <li><span>Increase the separation between the equipment and receiver.</span></li>
                            <li><span>Connect the equipment into an outlet on a circuit different from that to which the receiver is connected.</span></li>
                            <li><span>Contact <a href="mailto:support@eero.com">support@eero.com</a> or an experienced radio/TV technician for help.</span></li>
                        </ul>
                    </li>
                    <li>
                        <h3>FCC guidelines for human exposure</h3>
                        <p>The eero device complies with FCC radiation exposure limits set forth for an uncontrolled environment. The eero device should be installed and operated with minimum distance of 20 cm between the radiator and your body.</p>
                    </li>
                    <li>
                        <h3>FCC information to user</h3>
                        <p>The eero device does not contain any user serviceable components and is to be used with approved antennas only. Any product changes or modifications will invalidate all applicable regulatory certifications and approvals.</p>
                        <p>The eero device and its antenna(s) must not be co-located or operated in conjunction with any other antenna or transmitter.</p>
                    </li>
                </ol>
            </section>
        );
    },
    getInitialState() {
        return {};
    }
});

export default Marty.createContainer(Compliance, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/legal/views/compliance/Handler.js
 **/